import { render, staticRenderFns } from "./UserRolesList.vue?vue&type=template&id=0502b3c6"
import script from "./UserRolesList.vue?vue&type=script&lang=js"
export * from "./UserRolesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports